// @flow
import { SortDirection as SORT_DIRECTION } from '@box/react-virtualized/dist/es/Table/index';

const { ASC, DESC } = SORT_DIRECTION;

type SortDirection = ASC | DESC;

type SortParams = {
    defaultSortDirection: string,
    event: MouseEvent,
    sortBy: string,
    sortDirection: SortDirection,
};

export type { SortDirection, SortParams };
